import React from "react";
import styled from "styled-components";
import useI18n from "../../i18n/useI18n";
import privacyContent from "./data";

const DocumentsContainer = styled.div`
    padding: 1em;
    max-width: 900px;
    margin: 0 auto;
    color: #333;

    h1 {
        font-size: 2.5rem;
        font-weight: bold;
    }

    h2 {
        font-size: 1.8rem;
        font-weight: bold;
    }

    h3 {
        font-size: 1.4rem;
    }

    p {
        font-size: 1rem;
        line-height: 1.6;
        margin-bottom: 1em;
    }

    ul,
    ol {
        margin: 1em 0;
        padding-left: 1.5em;
    }

    li {
        margin-bottom: 0.5em;
    }

    a {
        color: #1a73e8;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
`;

const Policy = () => {
    const { translateObject } = useI18n();

    return (
        <DocumentsContainer>
            <h1>{translateObject(privacyContent.title)}</h1>
            <p>
                <strong>{translateObject(privacyContent.effectiveDate)}</strong>{" "}
                {translateObject(privacyContent.date)}
            </p>
            <p>{translateObject(privacyContent.introduction)}</p>
            <h2>
                1.{" "}
                {translateObject(privacyContent.infoCollectedTitle)}
            </h2>
            <h3>
                a.{" "}
                {translateObject(privacyContent.infoCollectedBusinessTitle)}
            </h3>
            <ul>
                <li>{translateObject(privacyContent.infoCollectedBusiness).split(",")[0]}</li>
                <li>{translateObject(privacyContent.infoCollectedBusiness).split(",")[1]}</li>
                <li>{translateObject(privacyContent.infoCollectedBusiness).split(",")[2]}</li>
            </ul>
            <h3>
                b.{" "}
                {translateObject(privacyContent.infoCollectedUsersTitle)}
            </h3>
            <ul>
                <li>{translateObject(privacyContent.infoCollectedEnd).split(",")[0]}</li>
                <li>{translateObject(privacyContent.infoCollectedEnd).split(",")[1]}</li>
                <li>{translateObject(privacyContent.infoCollectedEnd).split(",")[2]}</li>
            </ul>

            <h2>
                2.{" "}
                {translateObject({
                    en: "How We Use Information",
                    es: "Cómo Usamos la Información",
                })}
            </h2>
            <ul>
                {translateObject(privacyContent.howWeUse)
                    .split(",")
                    .map((item, index) => (
                        <li key={index}>{item.trim()}</li>
                    ))}
            </ul>

            <h2>
                3.{" "}
                {translateObject({
                    en: "Sharing of Information",
                    es: "Compartición de Información",
                })}
            </h2>
            <ul>
                {translateObject(privacyContent.sharingInfo)
                    .split(",")
                    .map((item, index) => (
                        <li key={index}>{item.trim()}</li>
                    ))}
            </ul>
            <p>
                {translateObject({
                    en: "We do not sell personal information to third parties.",
                    es: "No vendemos información personal a terceros.",
                })}
            </p>

            <h2>
                4.{" "}
                {translateObject({
                    en: "Use of Cookies and Tracking Technologies",
                    es: "Uso de Cookies y Tecnologías de Seguimiento",
                })}
            </h2>
            <p>{translateObject(privacyContent.cookiesTracking)}</p>

            <h2>
                5.{" "}
                {translateObject({
                    en: "Your Rights and Choices",
                    es: "Sus Derechos y Opciones",
                })}
            </h2>
            <p>
                {translateObject({
                    en: "Depending on your jurisdiction, you may have rights to:",
                    es: "Dependiendo de su jurisdicción, puede tener derechos para:",
                })}
            </p>
            <ul>
                {translateObject(privacyContent.rightsAndChoices)
                    .split(",")
                    .map((item, index) => (
                        <li key={index}>{item.trim()}</li>
                    ))}
            </ul>
            <p>
                {translateObject(privacyContent.rightsInMexico)}
                <a href="mailto:privacy@appsinti.com">privacy@appsinti.com</a>.
            </p>

            <h2>6. {translateObject({ en: "Security Measures", es: "Medidas de Seguridad" })}</h2>
            <p>{translateObject(privacyContent.securityMeasures)}</p>

            <h2>7. {translateObject({ en: "Data Retention", es: "Retención de Datos" })}</h2>
            <p>{translateObject(privacyContent.dataRetention)}</p>

            <h2>
                8.{" "}
                {translateObject({
                    en: "International Data Transfers",
                    es: "Transferencias Internacionales de Datos",
                })}
            </h2>
            <p>{translateObject(privacyContent.internationalTransfers)}</p>

            <h2>9. {translateObject({ en: "Children's Privacy", es: "Privacidad Infantil" })}</h2>
            <p>{translateObject(privacyContent.childrensPrivacy)}</p>

            <h2>10. {translateObject({ en: "Contact Us", es: "Contáctenos" })}</h2>
            <p>
                {translateObject(privacyContent.contactUs)}
                <a href="mailto:privacy@appsinti.com">privacy@appsinti.com</a>.
            </p>
        </DocumentsContainer>
    );
};

export default Policy;
